interface Props {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  fullScreen?: boolean;
}

const SIZES = { sm: 18, md: 32, lg: 48 } as const;

export function Spinner({ size = 'md', label, fullScreen = false }: Props) {
  const px = SIZES[size];
  const wrapperStyle: React.CSSProperties = fullScreen
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        minHeight: 320,
        width: '100%',
      }
    : {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
      };

  return (
    <div style={wrapperStyle} role="status" aria-live="polite">
      <span
        className="spinner-ring"
        style={{ width: px, height: px }}
        aria-hidden="true"
      />
      {label ? (
        <span className="vs-label" style={{ color: 'var(--fg-muted)' }}>
          {label}
        </span>
      ) : null}
      <span className="sr-only" style={{ position: 'absolute', left: -9999 }}>
        {label ?? 'Loading'}
      </span>
    </div>
  );
}
